<template>
    <div class="personal-contacts-modal">
        <NoButtonModal :open="true">
            <div class="modal-list-third-party-app">
                <div
                    class="modal-content-header modal-list-third-party-app d-flex justify-content-between align-items-center ps-4 pe-2 py-1"
                >
                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <template v-if="showSelectSvgModal">
                            <span class="label-app-list-header">Select SVG</span>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="d-flex search-svg-icon mx-4 my-2">
                                    <input
                                        type="text"
                                        placeholder="Find icon here"
                                        v-model="searchedSvg"
                                        @input="handleSearchedSVG"
                                    />
                                    <img
                                        src="@/assets/px/drag-and-drop/search-icon.svg"
                                        alt=""
                                        class="img mx-2"
                                        style="width: 20px"
                                    />
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            <span class="label-app-list-header">Personal Contacts</span>
                        </template>
                    </div>
                </div>

                <template v-if="!loading">
                    <!-- SVG Picker -->
                    <template v-if="showSelectSvgModal">
                        <div class="section-body add-new-app-form mx-0">
                            <ValidationObserver ref="svgForm">
                                <form style="box-shadow: none">
                                    <div v-if="svgList.length > 0" class="d-flex flex-wrap mx-4 gap-2 py-3">
                                        <div
                                            v-for="(svg, index) in svgList"
                                            :key="index"
                                            class="svg-item d-flex justify-content-center align-items-center"
                                            :class="{ 'svg-selected': selectedSvg && selectedSvg.id === svg.id }"
                                            @click="selectedSvg = svg"
                                            style="cursor: pointer; width: 60px; height: 60px; border: 1px solid #ddd; border-radius: 6px;"
                                        >
                                            <img :src="svg.imageUrl" alt="" style="max-width: 40px; max-height: 40px" />
                                        </div>
                                    </div>
                                    <div v-else-if="searchedSvg !== ''" class="w-100 d-flex justify-content-center align-items-center py-5">
                                        <h4>No SVG available</h4>
                                    </div>
                                    <div v-else class="w-100 d-flex justify-content-center align-items-center py-5">
                                        <h4>No SVG Added</h4>
                                    </div>
                                    <div class="section-footer add-new-app-form my-4">
                                        <div class="d-flex justify-content-center">
                                            <button type="button" class="primary btn-save-application" @click="saveSvg">
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                class="no-bg text-button btn-cancel px-4"
                                                @click="showSelectSvgModal = false"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                    </template>

                    <!-- Config Form -->
                    <template v-else>
                        <div class="section-body add-new-app-form mx-0">
                            <ValidationObserver ref="form">
                                <form style="box-shadow: none">
                                    <!-- Icon -->
                                    <div
                                        class="app-img-upload block field-container d-flex align-items-center mb-2 mx-5 px-3"
                                    >
                                        <label class="me-3 d-flex justify-content-end add-new-app-label">Icon/Images*</label>
                                        <div class="d-flex align-items-center w-100 gap-1">
                                            <button
                                                type="button"
                                                class="w-40 no-bg text-button btn-add-new-app"
                                                @click="chooseFile"
                                            >
                                                Choose file
                                            </button>
                                            <button
                                                type="button"
                                                class="no-bg text-button btn-add-new-app w-40"
                                                @click="chooseFromCompany"
                                            >
                                                Choose icon
                                            </button>
                                            <input
                                                id="pcFileid"
                                                type="file"
                                                name="upload"
                                                ref="upload"
                                                size="100000"
                                                @change="uploadFile"
                                                hidden
                                                accept=".svg, .png, .jpg, .jpeg"
                                            />
                                            <div class="img-container-small d-flex justify-content-center align-items-center">
                                                <img
                                                    v-if="!uploadedImg && !showImgLoader && !isSvgPresent"
                                                    src="@/assets/px/drag-and-drop/dummyUploadImage.svg"
                                                />
                                                <img
                                                    v-if="!showImgLoader && isSvgPresent"
                                                    :src="svgToBase64"
                                                    alt="image not found"
                                                />
                                                <img
                                                    v-if="uploadedImg && !showImgLoader && !isSvgPresent"
                                                    :src="uploadedImg"
                                                    alt="image not uploaded"
                                                />
                                                <div class="d-flex flex-column" v-if="showImgLoader" style="margin-top: 15px">
                                                    <div class="d-flex justify-content-center align-items-center img-loader-main">
                                                        <b-spinner variant="primary" class="img-loader"></b-spinner>
                                                    </div>
                                                    <span class="img-loader-text">Uploading...</span>
                                                </div>
                                                <ejs-tooltip
                                                    v-if="uploadedImg || svgImg"
                                                    class="tooltipcontainer"
                                                    content="Delete"
                                                    target="#target"
                                                    cssClass="customtooltip"
                                                    position="top"
                                                >
                                                    <span
                                                        id="target"
                                                        class="material-symbols-outlined img-delete-small"
                                                        role="button"
                                                        @click="resetFileUpload"
                                                    >
                                                        delete
                                                    </span>
                                                </ejs-tooltip>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Color Scheme -->
                                    <div class="d-flex flex-wrap my-4 flex-column gap-2">
                                        <div class="d-flex color-box w-100">
                                            <div class="d-flex my-2 mx-4 w-100">
                                                <div class="d-flex align-items-center w-40" style="gap: 1%">
                                                    <input
                                                        type="radio"
                                                        name="pc_color_type"
                                                        id="pc_primary_colors"
                                                        value="primary_colors"
                                                        style="transform: scale(0.8)"
                                                        v-model="functionInfo.selectedSchemeOption"
                                                        @change="selectColorScheme($event)"
                                                    />
                                                    <label for="pc_primary_colors" style="font-weight: bold">Primary Color Option</label>
                                                </div>
                                                <label class="d-flex py-2 w-60" style="gap: 5px">
                                                    <div
                                                        v-for="(value, index) in colorScheme.primary_colors"
                                                        :key="index"
                                                        class="d-flex align-items-center px-2 w-25 text-uppercase color-box-item"
                                                        :style="{ background: value }"
                                                    >
                                                        {{ value }}
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-flex color-box w-100">
                                            <div class="d-flex my-2 mx-4 w-100">
                                                <div class="d-flex align-items-center w-40" style="gap: 1%">
                                                    <input
                                                        type="radio"
                                                        name="pc_color_type"
                                                        id="pc_secondary_colors"
                                                        value="secondary_colors"
                                                        style="transform: scale(0.8)"
                                                        v-model="functionInfo.selectedSchemeOption"
                                                        @change="selectColorScheme($event)"
                                                    />
                                                    <label for="pc_secondary_colors" style="font-weight: bold">Secondary Color Option</label>
                                                </div>
                                                <label class="d-flex py-2 w-60" style="gap: 5px">
                                                    <div
                                                        v-for="(value, index) in colorScheme.secondary_colors"
                                                        :key="index"
                                                        class="d-flex align-items-center px-2 w-25 text-uppercase color-box-item"
                                                        :style="{ background: value }"
                                                    >
                                                        {{ value }}
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        <div v-if="isCustomizedThemeSelected" class="d-flex color-box w-100">
                                            <div class="d-flex my-2 mx-4 w-100">
                                                <div class="d-flex align-items-center w-40" style="gap: 1%">
                                                    <input
                                                        type="radio"
                                                        name="pc_color_type"
                                                        id="pc_customized_colors"
                                                        value="customized_colors"
                                                        style="transform: scale(0.8)"
                                                        v-model="functionInfo.selectedSchemeOption"
                                                        @change="selectColorScheme($event)"
                                                    />
                                                    <label for="pc_customized_colors" style="font-weight: bold">Custom Color Option</label>
                                                </div>
                                                <label class="d-flex py-2 w-60" style="gap: 5px">
                                                    <div
                                                        v-for="(value, index) in colorScheme.customized_colors"
                                                        :key="index"
                                                        class="d-flex align-items-center px-2 w-25 text-uppercase color-box-item"
                                                        :style="{ background: value }"
                                                    >
                                                        {{ value }}
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-flex color-box w-100">
                                            <div class="d-flex my-2 mx-4 w-100">
                                                <div class="d-flex align-items-center w-40" style="gap: 1%">
                                                    <input
                                                        type="radio"
                                                        name="pc_color_type"
                                                        id="pc_module_customized_colors"
                                                        value="module_customized_colors"
                                                        style="transform: scale(0.8)"
                                                        v-model="functionInfo.selectedSchemeOption"
                                                        @change="selectColorScheme($event)"
                                                    />
                                                    <label for="pc_module_customized_colors" style="font-weight: bold">Custom Module Color Option</label>
                                                </div>
                                                <label class="d-flex py-2 w-60" style="gap: 5px">
                                                    <div
                                                        v-for="(value, index) in colorScheme.module_customized_colors"
                                                        :key="index"
                                                        class="d-flex align-items-center px-2 w-25"
                                                    >
                                                        <input
                                                            v-if="functionInfo.selectedSchemeOption === 'module_customized_colors'"
                                                            type="color"
                                                            v-model="colorScheme.module_customized_colors[index]"
                                                            @change="selectCustomColorScheme($event, index)"
                                                            class="w-100 p-0"
                                                        />
                                                        <div v-else class="default-color"></div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Title -->
                                    <div class="mx-5 px-3">
                                        <Input
                                            label="Title"
                                            labelClass="w-40 me-3 d-flex justify-content-end add-new-app-label"
                                            type="text"
                                            class="field-container d-flex align-items-center mb-4"
                                            name="title"
                                            placeholder="Enter Title"
                                            v-model="functionInfo.title"
                                            required
                                        />
                                        <span class="field-container d-flex align-items-center mt-2 mb-4">
                                            <label
                                                for="pc_category"
                                                class="me-3 d-flex add-new-app-label justify-content-end"
                                                style="width: 28%"
                                            >Category</label>
                                            <Multiselect
                                                id="pc_category"
                                                track-by="id"
                                                label="title"
                                                class="w-70"
                                                placeholder="Search or Select Category"
                                                v-model="categoryInfo"
                                                :options="categoryList"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                @input="functionInfo.module_category = $event.id"
                                            />
                                        </span>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>

                        <div class="section-footer add-new-app-form my-4">
                            <div class="d-flex justify-content-center">
                                <button
                                    type="button"
                                    class="primary btn-save-application"
                                    :disabled="showImgLoader"
                                    @click="updateGenericModule"
                                >
                                    Save
                                </button>
                                <button type="button" class="no-bg btn-cancel px-4" @click="handleCancel">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </template>
                </template>

                <div
                    v-if="loading"
                    class="d-flex flex-column justify-content-center align-items-center loader-main"
                    style="min-height: 25rem"
                >
                    <b-spinner variant="primary" class="add-list-function-loader mb-1"></b-spinner>
                    <span class="ms-3">Loading ...</span>
                </div>
            </div>
        </NoButtonModal>
    </div>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    import { ValidationObserver } from 'vee-validate';
    import { memberProfile, svgPicker } from '@/util/apiRequests';
    import { category } from '@/util/apiRequests';

    const initialFunctionInfoState = {
        title: '',
        image: '',
        module_category: null,
        selectedSchemeOption: 'primary_colors',
        primaryColor: '',
        secondaryColor: '',
        color: '',
        textColor: '',
    };

    export default {
        name: 'PersonalContactsEditModal',
        components: { NoButtonModal, ValidationObserver },
        props: {
            clickedProfileFunction: {
                type: String,
                required: true,
            },
            position: {
                type: String,
                required: true,
            },
            applicationFrame: {
                type: String,
                required: true,
            },
            pageData: {
                type: Object,
            },
            dashboardId: {
                type: Number,
            },
            group: {
                type: String,
            },
        },
        data() {
            return {
                functionInfo: { ...initialFunctionInfoState },
                loading: true,
                uploadedImg: '',
                svgImg: '',
                searchedSvg: '',
                allSvgList: [],
                svgList: [],
                selectedSvg: {},
                colorScheme: {},
                showImgLoader: false,
                isSvgPresent: false,
                showSelectSvgModal: false,
                isModuleLogoUpdated: false,
                categoryInfo: '',
                categoryList: [],
                isCustomizedThemeSelected: false,
            };
        },
        computed: {
            svgToBase64() {
                if (!this.svgImg) return;
                const base64Svg = btoa(this.svgImg.outerHTML);
                return 'data:image/svg+xml;base64,' + base64Svg;
            },
        },
        methods: {
            async getCategories() {
                try {
                    const endpoint = category.getCategories(this.$store.state.user.company_id);
                    const response = await this.$api.get(endpoint);
                    this.categoryList = response.data ?? [];
                } catch {
                    this.$toasted.error('Failed to fetch Categories.');
                }
            },
            async fetchApplications() {
                try {
                    const endpoint = memberProfile.getSpecificGenericFunction(
                        this.clickedProfileFunction,
                        this.position,
                        this.dashboardId,
                        this.applicationFrame,
                        this.group === 'LI' ? 'Upper' : 'Lower'
                    );
                    const functionResponse = await this.$api.get(endpoint);
                    if (!functionResponse) throw 'e';

                    const { info } = functionResponse.data;
                    if (info.length) {
                        this.functionInfo.id = info[0].id;
                        this.functionInfo.title = info[0].title;
                        this.functionInfo.image = info[0].image;
                        this.functionInfo.color = info[0].color;
                        this.functionInfo.textColor = info[0].textColor;
                        this.functionInfo.primaryColor = info[0].primaryColor;
                        this.functionInfo.secondaryColor = info[0].secondaryColor;
                        this.functionInfo.selectedSchemeOption = info[0].selectedSchemeOption;
                        this.functionInfo.module_category = info[0].module_category;
                        this.uploadedImg = info[0].imageUrl;

                        this.categoryInfo = this.categoryList.find((c) => c.id === info[0].module_category);
                    }
                } catch {
                    this.$toasted.error('Failed to fetch widget configuration.');
                }
            },
            fetchColorScheme() {
                try {
                    const colorScheme = this.pageData?.page3?.colorScheme;
                    if (!colorScheme) throw 'e';

                    if (colorScheme.primary_colors !== undefined) {
                        // mobex-health-home / mobex-health-plus / kiosk structure
                        this.colorScheme = {
                            primary_colors: colorScheme.primary_colors ?? [],
                            secondary_colors: colorScheme.secondary_colors ?? [],
                            customized_colors: colorScheme.customized_colors ?? [],
                            module_customized_colors: colorScheme.module_customized_colors ?? ['', '', '', ''],
                        };
                        this.isCustomizedThemeSelected = !!(colorScheme.customized_colors?.length);
                    } else {
                        // mobex-health-hub structure: colors is array of [bgColor, textColor] pairs
                        const colors = colorScheme.colors ?? [];
                        const toRow = (entry) => (entry ? [entry[0] ?? '', entry[1] ?? '', '', ''] : []);
                        this.colorScheme = {
                            primary_colors: toRow(colors[0]),
                            secondary_colors: toRow(colors[1]),
                            customized_colors: [],
                            module_customized_colors: ['', '', '', ''],
                        };
                        this.isCustomizedThemeSelected = false;
                    }
                } catch {
                    this.$toasted.error('Failed to fetch color scheme.');
                }
            },
            selectColorScheme(event) {
                const scheme = this.colorScheme[event.target.value];
                if (scheme) {
                    this.functionInfo.primaryColor = scheme[0] ?? '';
                    this.functionInfo.secondaryColor = scheme[1] ?? '';
                }
            },
            selectCustomColorScheme(event, index) {
                this.colorScheme.module_customized_colors[index] = event.target.value;
                this.functionInfo.primaryColor = this.colorScheme.module_customized_colors[0] ?? '';
                this.functionInfo.secondaryColor = this.colorScheme.module_customized_colors[1] ?? '';
            },
            chooseFile() {
                this.$refs.upload.click();
            },
            async chooseFromCompany() {
                try {
                    const endpoint = svgPicker.getSvgList(this.$store.state.user.company_id);
                    const response = await this.$api.get(endpoint);
                    this.allSvgList = response?.data?.rows ?? [];
                    this.svgList = [...this.allSvgList];
                    this.showSelectSvgModal = true;
                } catch {
                    this.$toasted.error('Failed to load SVG list.');
                }
            },
            handleSearchedSVG() {
                if (!this.searchedSvg) {
                    this.svgList = [...this.allSvgList];
                    return;
                }
                this.svgList = this.allSvgList.filter((svg) =>
                    svg.title?.toLowerCase().includes(this.searchedSvg.toLowerCase())
                );
            },
            async saveSvg() {
                if (!this.selectedSvg?.id) return;
                try {
                    const endpoint = svgPicker.getSvgById(this.selectedSvg.id);
                    const response = await this.$api.get(endpoint);
                    const parser = new DOMParser();
                    const svgDoc = parser.parseFromString(response.data, 'image/svg+xml');
                    this.svgImg = svgDoc.documentElement;
                    this.isSvgPresent = true;
                    this.uploadedImg = '';
                    this.functionInfo.image = this.selectedSvg.fileId;
                    this.isModuleLogoUpdated = true;
                    this.showSelectSvgModal = false;
                } catch {
                    this.$toasted.error('Failed to load SVG.');
                }
            },
            async uploadFile(event) {
                if (!event.target.files.length) return;
                const file = event.target.files[0];
                const fileName = file.name;
                const fileSize = file.size;
                const fileExtension = fileName.split('.').pop();

                if (!['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG', 'svg'].includes(fileExtension)) {
                    this.$toasted.error('Only svg, png, jpg/jpeg files are allowed');
                    this.$refs.upload.value = '';
                    return;
                }
                if (fileSize / 1024 / 1024 > 10) {
                    this.$toasted.error('Image size should be less than 10MB');
                    this.$refs.upload.value = '';
                    return;
                }

                try {
                    this.showImgLoader = true;

                    if (fileExtension.toLowerCase() === 'svg') {
                        const readerResult = await new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = (e) => resolve(e.target.result);
                            reader.onerror = (err) => reject(err);
                            reader.readAsDataURL(file);
                        });
                        this.uploadedImg = readerResult;
                        const parser = new DOMParser();
                        const svgDoc = parser.parseFromString(atob(readerResult.split(',')[1]), 'image/svg+xml');
                        this.svgImg = svgDoc.documentElement;
                        this.isSvgPresent = true;
                        this.isModuleLogoUpdated = true;
                    } else {
                        const formData = new FormData();
                        formData.append('file', file);
                        const endpoint = memberProfile.uploadProfileFunctionsImage();
                        const response = await this.$api.post(endpoint, formData);
                        if (!response.data.success) {
                            throw response.data.error;
                        }
                        this.functionInfo.image = response.data.s3_link;
                        this.uploadedImg = URL.createObjectURL(file);
                        this.isSvgPresent = false;
                        this.isModuleLogoUpdated = true;
                        this.$toasted.success('Image uploaded successfully!');
                    }
                } catch (e) {
                    this.$toasted.error(e ? e : 'Failed to upload image.');
                    this.$refs.upload.value = '';
                } finally {
                    this.showImgLoader = false;
                }
            },
            resetFileUpload() {
                this.uploadedImg = '';
                this.svgImg = '';
                this.isSvgPresent = false;
                this.functionInfo.image = '';
                this.isModuleLogoUpdated = false;
            },
            async updateGenericModule() {
                try {
                    const isValid = await this.$refs.form.validate();
                    if (!isValid) return;

                    this.loading = true;
                    const data = {
                        title: this.functionInfo.title,
                        image: this.functionInfo.image,
                        color: this.functionInfo.color,
                        textColor: this.functionInfo.textColor,
                        primaryColor: this.functionInfo.primaryColor,
                        secondaryColor: this.functionInfo.secondaryColor,
                        selectedSchemeOption: this.functionInfo.selectedSchemeOption,
                        module_category: this.functionInfo.module_category,
                        position: this.position,
                        assigned_to: 'PersonalContacts',
                        dashboard_assigned: this.dashboardId,
                        application: this.applicationFrame,
                        section: this.group === 'LI' ? 'Upper' : 'Lower',
                        lumecatitle: '',
                    };

                    if (this.functionInfo.id) {
                        const endpoint = memberProfile.updateGenericModule(this.functionInfo.id);
                        await this.$api.put(endpoint, data);
                    } else {
                        const endpoint = memberProfile.createGenericModule();
                        await this.$api.post(endpoint, data);
                    }

                    this.$toasted.success('Personal Contacts widget configured successfully.');
                    this.$emit('widgetSaved');
                    this.$emit('cancel');
                } catch {
                    this.$toasted.error('Failed to save widget configuration.');
                } finally {
                    this.loading = false;
                }
            },
            handleCancel() {
                this.$emit('cancel');
            },
        },
        async created() {
            await this.getCategories();
            this.fetchColorScheme();
            await this.fetchApplications();
            this.loading = false;
        },
    };
</script>
